import { replaceStaticWithCdnFromImageUrls } from "./functions";

const getAccordionSectionProps = content => {
  const title = content.querySelector('[data-element=title]').innerHTML;
  return {
    id: title.replaceAll(' ','-'),
    title,
    content:content.querySelector('[data-element=content]')
  }
}
const getVideoProps = (content) => {
  /* const videoSrc = content.querySelector('.pagebuilder-video-container [data-element=video]').src
    const autoplay = !!content.querySelector('[autoplay]')
    const childPbStyle = content.querySelector('.pagebuilder-video-inner').dataset.pbStyle */
  const videoContent = content.innerHTML;
  return {
    /* videoSrc,
        autoplay,
        childPbStyle */
    videoContent,
    muted: true,
    loop:true
  };
};

const getBannerProps = (content) => {
  const link = content.querySelector('[data-element=link]');
  const wrapper = content.querySelector('[data-element=wrapper]');
  const overlay = content.querySelector('[data-element=overlay]');
  const videoOverlay = content.querySelector('[data-element=video_overlay]');
  const textContent = content.querySelector('[data-element=content]');
  const previewContent = content.querySelector('[data-element=preview_content]');
  const button = content.querySelector('[data-element=button]');
  return {
    buttonText: button?.innerHTML,
    title: content?.title,
    content: {
      text: textContent.innerHTML,
      previewText: previewContent?.innerHTML,
      pbStyle: textContent.dataset.pbStyle,
    },
    bannerDatas: {
      link: link ? link.href : null,
      linkTargetBlank: link && link.target == '_blank',
      ...wrapper.dataset,
      title: overlay.title,
      alt: overlay.getAttribute('aria-label'),
      contentOverlay: {
        showType: content.dataset.showOverlay, /** @TODO check if needed */
        ...overlay.dataset,

      },
      ...(videoOverlay ? { videoOverlay: { ...videoOverlay.dataset } } : {}),

    },
  };
};
/**
 * This was made for SEO purposes
 * Derives alt from src, if not present.
 * @param src - The source of the image
 * @returns The alt text
 */
const deriveAltFromSrc = (src: string) => {
  const clean = decodeURIComponent(src.split('#')[0].split('?')[0]);
  const file = (clean.split('/').pop() || '').replace(/\.[a-z0-9]+$/i, '');
  return file.replace(/[-_]+/g, ' ').trim();
};

const getImagesProps = (content, imageConfig) => {
  const { IMAGE_STATIC_REPLACEMENT, IMAGE_CDN_REPLACEMENT } = imageConfig;
  const desktopImg = content.querySelector('img[data-element="desktop_image"]');
  const mobileImg = content.querySelector('img[data-element="mobile_image"]');

  return {
    desktopImg: {
      alt: desktopImg.alt || deriveAltFromSrc(desktopImg.src),
      title: desktopImg?.title || '',
      src: replaceStaticWithCdnFromImageUrls(desktopImg?.src || '', IMAGE_STATIC_REPLACEMENT, IMAGE_CDN_REPLACEMENT)
    },
    mobileImg: {
      src: replaceStaticWithCdnFromImageUrls(mobileImg?.src || '', IMAGE_STATIC_REPLACEMENT, IMAGE_CDN_REPLACEMENT)
    }
  }

}

const getRowProps = (node) => {
  try {
    const innerDataset = { ...node.children[0].dataset }; /** Do not remove object assignation. it will break the children composition */
    innerDataset.childPbStyle = innerDataset.pbStyle;
    delete innerDataset.pbStyle;
    delete innerDataset.contentType;
    delete innerDataset.styles;
    delete innerDataset.mediaQueries;
    /** Le row "full-bleed" hanno show-in-preview/show-online direttamente sul nodo row: in quel caso vince il valore
     * proprio della row. Le row "contained" li portano invece solo sul wrapper "inner" (questo children[0]): in
     * quel caso vanno lasciati passare come fallback, altrimenti si perdono e il default (true) prende il sopravvento. */
    if (node.dataset.showOnline !== undefined) delete innerDataset.showOnline;
    if (node.dataset.showInPreview !== undefined) delete innerDataset.showInPreview;
    const videoOverlay = node.querySelector('[data-element=video_overlay]');
    return {
      ...innerDataset,
      videoOverlayColor: videoOverlay?.dataset?.videoOverlayColor,
    };
  } catch { return {}; }
};

const getProductsProps = (content) => {
  const products = content.querySelectorAll('.product-item-actions form[data-role=tocart-form]');
  return { skus: [...products].map((product) => product.dataset.productSku) };
};

export const getCustomProps = (node, content, imageConfig) => {
  switch (content.dataset.contentType) {
    case 'accordion-section': return getAccordionSectionProps(node);
    case 'row': return getRowProps(node);
    case 'video': return getVideoProps(content);
    case 'banner':
    case 'evidences':
    case 'evidence':
    case 'slide': return getBannerProps(content);
    case 'products': return getProductsProps(content);
    case 'image': return getImagesProps(content, imageConfig);
    default: return {};
  }
};
